import Icon from '../components/Icon.vue'

Icon.register({
  'thermometer-three-quarters': {
    width: 256,
    height: 512,
    paths: [
      {
        d: 'M192 384c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-23.7 12.9-44.3 32-55.4v-168.6c0-17.7 14.3-32 32-32s32 14.3 32 32v168.6c19.1 11.1 32 31.7 32 55.4zM224 299.3c19.9 22.6 32 52.2 32 84.7 0 70.7-57.3 128-128 128-0.3 0-0.6 0-0.9 0-70.3-0.5-127.4-58.4-127.1-128.7 0.2-32.2 12.2-61.6 32-84v-203.3c0-53 43-96 96-96s96 43 96 96v203.3zM208 384c0-34.3-19.4-52.2-32-66.5v-221.5c0-26.5-21.5-48-48-48s-48 21.5-48 48v221.5c-12.7 14.4-31.8 32.1-32 66.1-0.2 43.9 35.6 80.1 79.4 80.4l0.6 0c44.1 0 80-35.9 80-80z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/thermometer-three-quarters.js
// module id = 2004
// module chunks = 0